import React from 'react';

export type CaseStatus =
  | 'Recibido'
  | 'En Revisión' |'En Litigio' |'Resolución Pendiente' |'Aprobado' |'Recuperación en Proceso' |'Cerrado';

const statusConfig: Record<
  CaseStatus,
  { className: string; dot: string }
> = {
  Recibido: {
    className: 'status-recibido',
    dot: 'bg-[var(--status-recibido)]',
  },
  'En Revisión': {
    className: 'status-revision',
    dot: 'bg-[var(--status-revision)]',
  },
  'En Litigio': {
    className: 'status-litigio',
    dot: 'bg-[var(--status-litigio)]',
  },
  'Resolución Pendiente': {
    className: 'status-resolucion',
    dot: 'bg-[var(--status-resolucion)]',
  },
  Aprobado: {
    className: 'status-aprobado',
    dot: 'bg-[var(--status-aprobado)]',
  },
  'Recuperación en Proceso': {
    className: 'status-recuperacion',
    dot: 'bg-[var(--status-recuperacion)]',
  },
  Cerrado: {
    className: 'status-cerrado',
    dot: 'bg-[var(--status-cerrado)]',
  },
};

interface StatusBadgeProps {
  status: CaseStatus;
  size?: 'sm' | 'md' | 'lg';
}

export default function StatusBadge({
  status,
  size = 'md',
}: StatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig['Recibido'];
  const sizeClass =
    size === 'sm' ?'text-[11px] px-2 py-0.5 gap-1.5'
      : size === 'lg' ?'text-sm px-3 py-1.5 gap-2' :'text-xs px-2.5 py-1 gap-1.5';

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${sizeClass} ${config.className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`} />
      {status}
    </span>
  );
}